export default {
    TITLE_STYLE: {
        CAP_ALL_WORDS: 'CAP_ALL_WORDS', // 除了连词，所有单词大写
        CAP_FIRST_WORD: 'CAP_FIRST_WORD' // 首字母大写
    },
    FONT_STYLE: {
        NORMAL: 'NORMAL',
        BOLD: 'BOLD',
        ITALIC: 'ITALIC',
        BOLD_ITALIC: 'BOLD_ITALIC'
    }
}


// WEBPACK FOOTER //
// ./src/constants/settingOptions.js